import {
  GridColDef,
  GridRenderCellParams,
  GridRowModesModel,
} from "@mui/x-data-grid";
import GridViewMUIX from "../../../../components/GridViewMUIX";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";
import { getRoutes } from "src/utilities/routes";
import { IAgreement } from "src/interface/IAgreement";
import AccordingTemplate from "./AccordingTemplate";
import { Box } from "@mui/material";
import SkeltonProgress from "src/components/SkeltonProgress";
import { IService } from "src/interface/IService";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";
const AgreementServiceItemList = ({
  customerId,
  setIsAgreement,
  setIsAgreementPayed,
  setAgreementAmount,
  setAgreementRef,
}: {
  customerId: string;
  setIsAgreement: (isAgreement: boolean) => void;
  setIsAgreementPayed: (isAgreementPayed: boolean) => void;
  setAgreementAmount: (agreementAmount: number) => void;
  setAgreementRef: (agreementRef: number | undefined) => void;
}) => {
  const notifications = useNotifications();
  const Routes = getRoutes();
  const [rows, setRows] = useState<IAgreement[]>([]);

  const [getServices, setServices] = useState<IAutoCompleteLabelValue[]>([]);
  const { mutate: fetchServices, isPending: isLoadingServices } = useMutation({
    mutationKey: ["ServicesData"],
    mutationFn: () =>
      fetch(Routes.ServicesRoutes, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }).then((res) => res.json()),
    onSuccess: (data: IService[]) => {
      setServices(
        data.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      );
    },
    onError: (error) => {
      console.error("خطا در دریافت خدمات:", error);
    },
  });

  const {
    mutate: getAgreementByUserId,
    isPending: isAgreementByUserIdLoading,
  } = useMutation({
    mutationFn: async (id: string) => {
      const response = await fetch(Routes.AgreementsRoutes + "customer/" + id, {
        method: "GET",
        headers: {
          Aceept: "application/json",
        },
      });
      console.log("🚀 ~ mutationFn: ~ response:", response);
      return await response.json();
    },
    onSuccess: (responseData: IAgreement[]) => {
      if (responseData && responseData.length > 0) {
        const sortedData = [...responseData].sort((a, b) => {
          const dateA = new Date(a.startedAt || 0);
          const dateB = new Date(b.startedAt || 0);
          return dateB.getTime() - dateA.getTime(); // مرتب‌سازی نزولی
        });
        setRows(sortedData);
        setIsAgreement(true);
      } else {
        setIsAgreement(false);
      }
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });
  const [agreement, setAgreement] = useState<IAgreement>();

  useEffect(() => {
    if (customerId) {
      getAgreementByUserId(customerId);
      fetchServices();
    }
  }, [customerId]);

  useEffect(() => {
    if (rows.length > 0) {
      setAgreement(rows[0]);
      setAgreementAmount(rows[0].price ?? 0);
      setAgreementRef(rows[0].id ?? undefined);
      console.log(rows[0]);

      if (
        rows[0].transactions &&
        rows[0].transactions.filter((t) => t.transactionStatus === 1)?.length >
          0
      ) {
        setIsAgreementPayed(true);
      }
    }
  }, [rows]);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const columns: GridColDef[] = [
    {
      field: "serviceRef",
      headerName: "خدمات مندرج در قرارداد",
      align: "left",
      headerAlign: "left",
      flex: 1,
      type: "singleSelect",
      valueOptions: getServices,
    },
  ];

  if (rows.length === 0) return null;

  return (
    <Box>
      <>
        <AccordingTemplate
          title="نمایش قرارداد"
          key={"balance"}
          title2={
            "مبلغ قرارداد: " +
            (agreement?.transactions &&
            agreement?.transactions?.filter((t) => t.transactionStatus === 1)
              ?.length > 0
              ? "0"
              : agreement?.price?.toLocaleString() + " ریال")
          }
        >
          {isAgreementByUserIdLoading || isLoadingServices ? (
            <SkeltonProgress />
          ) : (
            <GridViewMUIX
              columns={columns}
              loading={isAgreementByUserIdLoading || isLoadingServices}
              rowModesModel={rowModesModel}
              sortFields={{ field: "transactionDate", sort: "asc" }}
              rows={agreement?.services ?? []}
              setRowModesModel={setRowModesModel}
              gridUniqueName="PayFactor"
              disableColumnFilter
              rowHeight={30}
              disableColumnMenu
              disableColumnSelector
              disableDensitySelector
              pageSize={100}
              showQuickFilter={false}
              getRowHeight={null}
              checkboxSelection={false}
            />
          )}
        </AccordingTemplate>
      </>
    </Box>
  );
};

export default AgreementServiceItemList;
